<template>
    <div class="fullPage">
        <img src="../../../assets/image/banner/banner3.jpg" alt class="fullWidth"/>
        <div class="main-center main-top">
            <!--估价单查询-->
            <el-tabs type="border-card">
                <el-tab-pane :label="$t('estimate.estimateSearch')" class="searchComposite">
                    <div>
                        <div class="flex flex-space-around">
                            <!--估价单号-->
                            <div class="inputName">
                                <span class="inputName-title">
                                    {{$t('estimate.estimateNo')}}
                                </span>
                                <el-input v-model="estimateNo"
                                          :placeholder="$t('common.pleaseEnter')"
                                          clearable/>
                            </div>
                            <!--箱号-->
                            <div class="inputName">
                                <span class="inputName-title">
                                    {{$t('estimate.containerNo')}}
                                </span>
                                <el-input v-model="containerNo"
                                          :placeholder="$t('common.pleaseEnter')"
                                          clearable/>
                            </div>
                            <!--申请日期从-->
                            <div class="inputName">
                                <span class="inputName-title">
                                    {{$t('estimate.applyDateStart')}}
                                </span>
                                <el-date-picker v-model="search.applyDateStart" type="date" class="dateInput"
                                                :placeholder="$t('common.pleaseSelectDate')"/>
                            </div>
                            <!--申请日期到-->
                            <div class="inputName">
                                <span class="inputName-title">
                                    {{$t('estimate.applyDateEnd')}}
                                </span>
                                <el-date-picker v-model="search.applyDateEnd" type="date" class="dateInput"
                                                :placeholder="$t('common.pleaseSelectDate')"/>
                            </div>
                        </div>
                        <div class="flex flex-space-around topMargin">
                            <!--完成日期从-->
                            <div class="inputName">
                                <span class="inputName-title">
                                    {{$t('estimate.factFinalDateStart')}}
                                </span>
                                <el-date-picker v-model="search.factFinalDateStart" type="date" class="dateInput"
                                                :placeholder="$t('common.pleaseSelectDate')"/>
                            </div>
                            <!--完成日期到-->
                            <div class="inputName">
                                <span class="inputName-title">
                                    {{$t('estimate.factFinalDateEnd')}}
                                </span>
                                <el-date-picker v-model="search.factFinalDateEnd" type="date" class="dateInput"
                                                :placeholder="$t('common.pleaseSelectDate')"/>
                            </div>
                            <!--维修状态-->
                            <div class="inputName">
                                <span class="inputName-title">
                                    {{$t('estimate.repairStatus')}}
                                </span>
                                <el-select v-model="search.repairStatus"
                                           :placeholder="$t('common.pleaseSelect')">
                                    <el-option v-for="item in repairStatusOptions"
                                               :key="item.codeValue" :label="getCurLanguage() == 'en'? item.displayValue : item.displayValueCn"
                                               :value="item.codeValue">
                                        <span style="float: left">{{item.displayValue}}</span>
                                        <span style="float: right; color: #8492a6; font-size: 13px">{{item.displayValueCn}}</span>
                                    </el-option>
                                </el-select>
                            </div>
                            <div class="searchBtn">
                                <el-button type="primary" icon="el-icon-search"
                                           @click="searchBtnClick">
                                    {{searchButton}}
                                </el-button>
                                <el-button icon="el-icon-refresh"
                                           @click="resetBtnClick">
                                    {{resetButton}}
                                </el-button>
                            </div>
                        </div>
                    </div>
                </el-tab-pane>
            </el-tabs>
            <!--查询结果-->
            <div class="contentListCom">
                <result-bar>
                    <div slot="resultRight">
                        <!--全选-->
                        <el-button icon="el-icon-my-selectAll" @click="checkAllBtnClick(true)">
                            {{selectAll}}
                        </el-button>
                        <!--反选-->
                        <el-button icon="el-icon-my-selectInverse" @click="checkAllBtnClick(false)">
                            {{selectInverse}}
                        </el-button>
                        <!--修箱估价单导入-->
                        <el-button icon="el-icon-folder-add" @click="estimateExcelImport()">
                            {{$t('estimate.estimateExcelImport')}}
                        </el-button>
                        <!--修箱估价单导入(新)-->
                        <el-button icon="el-icon-folder-add" @click="estimateExcelImportNew()">
                            {{$t('estimate.estimateExcelImportNew')}}
                        </el-button>
                        <!--箱损图片导入-->
                        <el-button icon="el-icon-folder-add" @click="estimatePicturesBatchImport()">
                            {{$t('estimate.estimatePicturesBatchImport')}}
                        </el-button>
                        <!--修妥图片导入-->
                        <el-button icon="el-icon-folder-add" @click="completedPicturesBatchImport()">
                            {{$t('estimate.completedPicturesBatchImport')}}
                        </el-button>
                        <!--修箱完成-->
                        <el-button icon="el-icon-s-claim" @click="finishedAction()">
                            {{$t('estimate.repairFinishButton')}}
                        </el-button>
                        <vxe-switch v-model="showViewFlag" style="margin-left: 5px"
                                    open-label="common.cardView" close-label="common.tableView"
                                    open-icon="el-icon-notebook-2" close-icon="vxe-icon-table"
                                    open-value="card" close-value="table" @change="handleViewStyle">
                        </vxe-switch>
                    </div>
                </result-bar>
                <!--无数据组件-->
                <div v-if="showNoDataView || tableEstimateData.length === 0" class="noData">
                    <no-data-view/>
                </div>

                <!--查询结果-->
                <div class="contentListCom" v-else>
                    <!--展开视图-->
                    <div class="oneContent" v-for="(data,index) in tableEstimateData" :key="index" v-if="showViewFlag==='card'">
                        <template>
                            <div class="top overflow">
                                <template>
                                    <template>
                                        <!--多选控件-->
                                        <el-checkbox class="checkOne l" v-model="data.checked" :key="index"
                                                     @change="checkOneMethod(index,data.checked)"></el-checkbox>
                                        <!--估价单号-->
                                        <p class="listContent l">
                                            <span class="firstSpan">{{index+1+'. '+$t('estimate.estimateNo')}}：</span>
                                            <span class="secondSpan blueColor">{{data.estimateNo}}</span>
                                        </p>
                                        <!--港口/堆场-->
                                        <p class="listContent l">
                                            <span class="firstSpan">{{$t('estimate.portAndDepot')}}：</span>
                                            <span class="secondSpan">{{data.portCode}} / {{data.depotCode}}</span>
                                        </p>
                                        <!--申请日期-->
                                        <p class="listContent l">
                                            <span class="firstSpan">{{$t('estimate.applyDate')}}：</span>
                                            <span class="secondSpan">{{data.applyDate}}</span>
                                        </p>
                                    </template>
                                    <!--编辑按钮-->
                                    <el-button class="normalListButton r red-button feeDetail" size="small"
                                               @click="editBtnClick(data)">{{editButton}}</el-button>
                                </template>
                            </div>
                            <div class="center flexDiv">
                                <!--维修状态图标-->
                                <!--申请中-->
                                <div class="typeImg applyingEnImg" v-show="getCurLanguage() == 'en' && data.repairStatus == 'Applying'"/>
                                <div class="typeImg applyingImg" v-show="getCurLanguage() != 'en' && data.repairStatus == 'Applying'"/>
                                <!--已审批-->
                                <div class="typeImg approvedEnImg" v-show="getCurLanguage() == 'en' && data.repairStatus == 'Approved'"/>
                                <div class="typeImg approvedImg" v-show="getCurLanguage() != 'en' && data.repairStatus == 'Approved'"/>
                                <!--已拒绝-->
                                <div class="typeImg rejectedEnImg" v-show="getCurLanguage() == 'en' && data.repairStatus == 'Rejected'"/>
                                <div class="typeImg rejectedImg" v-show="getCurLanguage() != 'en' && data.repairStatus == 'Rejected'"/>
                                <!--修箱完成-->
                                <div class="typeImg finishedEnImg" v-show="getCurLanguage() == 'en' && data.repairStatus == 'Finished'"/>
                                <div class="typeImg finishedImg" v-show="getCurLanguage() != 'en' && data.repairStatus == 'Finished'"/>
                                <!--完成审核-->
                                <div class="typeImg finishApproveEnImg" v-show="getCurLanguage() == 'en' && data.repairStatus == 'FinishApprove'"/>
                                <div class="typeImg finishApproveImg" v-show="getCurLanguage() != 'en' && data.repairStatus == 'FinishApprove'"/>
                                <!--完成拒绝-->
                                <div class="typeImg finishRejectEnImg" v-show="getCurLanguage() == 'en' && data.repairStatus == 'FinishReject'"/>
                                <div class="typeImg finishRejectImg" v-show="getCurLanguage() != 'en' && data.repairStatus == 'FinishReject'"/>
                                <el-descriptions style="margin-right: 150px" size="medium" :column=4>
                                    <!--箱号-->
                                    <el-descriptions-item :label="$t('estimate.containerNo')">
                                        <el-tag size="medium" type="primary">{{data.containerNo}}</el-tag>
                                    </el-descriptions-item>
                                    <!--箱型-->
                                    <el-descriptions-item :label="$t('estimate.containerType')">
                                        <el-tag size="medium" class="blue_tag">{{data.containerType}}</el-tag>
                                    </el-descriptions-item>
                                    <!--船名/航次-->
                                    <el-descriptions-item :label="$t('estimate.vvl')">
                                        {{getCurLanguage() == 'en' ? data.vesselCode : data.vesselNameCn}} {{data.voyageNo}}
                                    </el-descriptions-item>
                                    <!--提单号-->
                                    <el-descriptions-item :label="$t('estimate.blNo')">{{data.blNo}}</el-descriptions-item>
                                    <!--币种-->
                                    <el-descriptions-item :label="$t('estimate.currency')">{{data.currency}}</el-descriptions-item>
                                    <!--箱损图片导入状态-->
                                    <el-descriptions-item :label="$t('estimate.picStatus')">{{data.picStatus === 'Y' ?
                                        $t('common.uploaded') : $t('common.unuploaded')}}</el-descriptions-item>
                                    <!--修妥图片导入状态-->
                                    <el-descriptions-item :label="$t('estimate.completePicStatus')">{{data.completePicStatus === 'Y' ?
                                        $t('common.uploaded') : $t('common.unuploaded')}}</el-descriptions-item>
                                    <!--审核日期-->
                                    <el-descriptions-item :label="$t('estimate.approveDate')">{{data.approveDate}}</el-descriptions-item>
                                    <!--实际完成日期-->
                                    <el-descriptions-item :label="$t('estimate.factFinalDate')">{{data.factFinalDate}}</el-descriptions-item>
                                </el-descriptions>
                            </div>
                        </template>
                        <div class="bottom overflow">
                            <!--总工费-->
                            <div class="l flexDiv leftMessage">
                                <p class="documentValid fontWeight msg">{{$t('estimateDetails.labTotal')}}：{{data.labTotal}}</p>
                            </div>
                            <!--总材料费-->
                            <div class="l flexDiv leftMessage">
                                <p class="documentValidLong fontWeight msg">{{$t('estimateDetails.matTotal')}}：{{data.matTotal}}</p>
                            </div>
                            <!--申请总费-->
                            <div class="l flexDiv leftMessage">
                                <p class="documentValid fontWeight msg">{{$t('estimateDetails.applyTotal')}}：{{data.applyTotal}}</p>
                            </div>
                            <!--审批总费-->
                            <div class="l flexDiv leftMessage">
                                <p class="documentValid fontWeight msg">{{$t('estimateDetails.approveTotal')}}：{{data.approveTotal}}</p>
                            </div>
                        </div>
                    </div>
                    <!--估价单数据表格pagination分页条-->
                    <div class="pagination" v-if="showViewFlag==='card'">
                        <div>
                            <el-pagination background layout="total,sizes,slot,prev, pager, next"
                                           max-height="600"
                                           :page-size="pageSize" :pager-count="pageCount"
                                           :page-sizes="[10, 20, 50, 100, 200]" :total="total"
                                           :current-page="pageNum"
                                           @size-change="handleSizeChange"
                                           @current-change="handleCurrentChange"/>
                        </div>
                    </div>

                    <!--表格视图-->
                    <div class="mainTable" v-if="showViewFlag==='table'">
                        <vxe-grid show-overflow
                                  ref="tableEstimateData" class="vxeTable"
                                  height="500" size="small"
                                  :row-config="{isCurrent: true, isHover: true}"
                                  :column-config="{resizable: true}"
                                  :export-config="{}"
                                  :checkbox-config="{checkStrictly: true}"
                                  @checkbox-change="handleTableDataChecked"
                                  resizable
                                  keep-source
                                  show-footer
                                  :data="tableEstimateData"
                                  :columns="tableColumn"
                                  :toolbar-config="tableToolbar">
                            <!--顶部工具栏插槽-->
                            <template #toolbar_buttons>
                                <vxe-button @click="exportDataEvent" status="primary" type="text" icon="vxe-icon-file-excel" style="margin-left: 10px">
                                    {{exportDataButton}}</vxe-button>
                                <vxe-button @click="$refs.tableEstimateData.hideColumn($refs.tableEstimateData.getColumnByField('menu'))" status="primary" type="text" icon="vxe-icon-eye-fill-close" style="margin-left: 10px">
                                    {{$t('common.menuHide')}}</vxe-button>
                                <vxe-button @click="$refs.tableEstimateData.showColumn($refs.tableEstimateData.getColumnByField('menu'))" status="primary" type="text" icon="vxe-icon-eye-fill" style="margin-left: 10px">
                                    {{$t('common.menuShow')}}</vxe-button>
                            </template>
                            <!--估价单号插槽-->
                            <template #column_estimateNo="{ row }">
                                <span class="secondSpan blueColor">{{row.estimateNo}}</span>
                            </template>
                            <!--港口/堆场插槽-->
                            <template #column_portAndDepot="{ row }">
                                <span>{{row.portCode}} / {{row.depotCode}}</span>
                            </template>
                            <!--箱号插槽-->
                            <template #column_containerNo="{ row }">
                                <el-tag size="mini" type="primary">{{row.containerNo}}</el-tag>
                            </template>
                            <!--箱型插槽-->
                            <template #column_containerType="{ row }">
                                <el-tag size="mini" class="blue_tag">{{row.containerType}}</el-tag>
                            </template>
                            <!--船名航次插槽-->
                            <template #column_vvl="{ row }">
                                {{getCurLanguage() == 'en' ? row.vesselCode : row.vesselNameCn}} {{row.voyageNo}}
                            </template>
                            <!--箱损图片导入状态插槽-->
                            <template #column_picStatus="{ row }">
                                <span v-if="row.picStatus === 'Y'" class="greenColor">{{$t('common.uploaded')}}</span>
                                <span v-else class="redColor">{{$t('common.unuploaded')}}</span>
                            </template>
                            <!--修妥图片导入状态插槽-->
                            <template #column_completePicStatus="{ row }">
                                <span v-if="row.completePicStatus === 'Y'" class="greenColor">{{$t('common.uploaded')}}</span>
                                <span v-else class="redColor">{{$t('common.unuploaded')}}</span>
                            </template>
                            <!--维修状态插槽-->
                            <template #column_repairStatus="{ row }">
                                <!--申请中-->
                                <span class="yellowColor" v-if="row.repairStatus == 'Applying'">{{getRepairStatusDisplayValue(row)}}</span>
                                <!--已审批-->
                                <span class="lightBlueColor0" v-else-if="row.repairStatus == 'Approved'">{{getRepairStatusDisplayValue(row)}}</span>
                                <!--已拒绝-->
                                <span class="redColor" v-else-if="row.repairStatus == 'Rejected'">{{getRepairStatusDisplayValue(row)}}</span>
                                <!--修箱完成-->
                                <span class="greenColor" v-else-if="row.repairStatus == 'Finished'">{{getRepairStatusDisplayValue(row)}}</span>
                                <!--完成审核-->
                                <span class="purpleColor" v-else-if="row.repairStatus == 'FinishApprove'">{{getRepairStatusDisplayValue(row)}}</span>
                                <!--完成拒绝-->
                                <span class="redColor" v-else-if="row.repairStatus == 'FinishReject'">{{getRepairStatusDisplayValue(row)}}</span>
                                <!--默认-->
                                <span v-else>{{getBlStatusDisplayValue(row)}}</span>
                            </template>
                            <!--操作按钮插槽-->
                            <template #operate_default="{ row }">
                                <div class="vxe-operate-default">
                                    <!--明细按钮-->
                                    <el-tooltip class="item" effect="dark" :content="viewDetails" placement="bottom-start">
                                        <el-button style="line-height: 15px; height: 22px; width: 22px"
                                                   size="mini" type="primary" icon="el-icon-edit" circle @click="editBtnClick(row)"></el-button>
                                    </el-tooltip>
                                </div>
                            </template>
                            <template #pager>
                                <vxe-pager
                                        :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']"
                                        :current-page.sync="pageNum"
                                        :page-size.sync="pageSize"
                                        :page-sizes="[10, 20, 50, 100, 200]"
                                        :total="total"
                                        @page-change="handleTablePageChange">
                                </vxe-pager>
                            </template>
                        </vxe-grid>
                    </div>
                </div>
            </div>
        </div>

        <!--估价单上传弹框-->
        <el-dialog
                :visible.sync="estimateUploadShow"
                width="770px" top="5%"
                :before-close="handleClose">
            <div slot="title" class="flex flex-align">
                <i class="el-icon-upload">{{this.newEstimateUploadFlag === 0 ? $t('estimate.estimateUpload') : $t('estimate.estimateUploadNew')}}</i>
            </div>
            <div class="el-upload__tip" style="color:#BC1920;margin-top: 10px;margin-bottom: 10px">{{$t('estimate.uploadTips1')}}</div>
            <div class="el-upload__tip" style="color:#BC1920;margin-top: 10px;margin-bottom: 10px">{{$t('estimate.uploadTips')}}</div>
            <el-row>
                <!--估价单上传-->
                <el-col style="width: 50%;">
                    <div class="cardTitle flex flex-align">
                        <i class="el-icon-s-order"></i>
                        <span>{{$t('estimate.estUpload')}}</span>
                    </div>
                    <el-upload
                            class="upload-demo"
                            drag multipart
                            ref="estimatesUpload"
                            :on-success="uploadSuccess"
                            action=""
                            :limit=5
                            accept=".xls,.xlsx"
                            :http-request="handleUpload"
                            :file-list="fileList"
                            :auto-upload="false">
                        <i class="el-icon-upload"></i>
                        <div class="el-upload__text">{{$t('common.dragUploadTips1')}}<em>{{$t('common.dragUploadTips2')}}</em></div>
                    </el-upload>
                </el-col>
                <!--修箱图片上传-->
                <el-col style="width: 50%;">
                    <div class="cardTitle flex flex-align">
                        <i class="el-icon-picture"></i>
                        <span>{{$t('estimate.picUpload')}}</span>
                    </div>
                    <el-upload
                            class="upload-demo"
                            drag multiple
                            ref="estimatePicturesUpload"
                            action=""
                            :limit=5
                            accept=".zip"
                            :http-request="handlePictureUpload"
                            :file-list="fileList"
                            :auto-upload="false">
                        <i class="el-icon-upload"></i>
                        <div class="el-upload__text">{{$t('common.dragUploadTips1')}}<em>{{$t('common.dragUploadTips2')}}</em></div>
                    </el-upload>
                </el-col>
            </el-row>
            <el-button style="margin-left: 10px;margin-top: 10px" size="small" type="warning" icon="el-icon-refresh"
                       @click="resetFileList">{{$t('common.resetButton')}}</el-button>
            <el-button style="margin-left: 10px;margin-top: 10px" size="small" type="success" icon="el-icon-upload2"
                       @click="uploadFile">{{$t('estimate.uploadFiles')}}</el-button>
            <el-popover
                    placement="bottom"
                    :title="$t('estimate.picUploadTips')"
                    width="270"
                    trigger="click">
                    <img src="../../../assets/image/estimatePicUploadTips.jpg" alt="">
                <el-button slot="reference" type="text" size="mini">
                    <el-link type="primary" style="font-size: 12px" icon="el-icon-info">{{$t('estimate.picUploadTips1')}}</el-link></el-button>
            </el-popover>
            <el-link v-show="newEstimateUploadFlag === 0" type="primary" style="font-size: 12px;margin-left: 10px" icon="el-icon-download" :underline="false"
                     href="/static/estimateImportTemplate.xls" download="ESTIMATE_IMPORT_TEMPLATE.xls">{{$t('estimate.excelTemplateDL')}}</el-link>
            <el-link v-show="newEstimateUploadFlag === 1" type="primary" style="font-size: 12px;margin-left: 10px" icon="el-icon-download" :underline="false"
                     href="/static/estimateImportNewTemplate.xls" download="ESTIMATE_IMPORT_TEMPLATE_NEW.xls">{{$t('estimate.excelTemplateDLNew')}}</el-link>
        </el-dialog>

        <!--箱损图片批量上传弹框-->
        <el-dialog
                :visible.sync="estimatePicturesBatchUploadShow"
                width="400px" top="5%"
                :before-close="handleClose">
            <div slot="title" class="flex flex-align">
                <i class="el-icon-upload">{{$t('estimate.picBatchUpload')}}</i>
            </div>
            <div class="el-upload__tip" style="color:#BC1920;margin-top: 10px;margin-bottom: 10px">{{$t('estimate.picBatchUploadTips')}}</div>
            <div class="el-upload__tip" style="color:#BC1920;margin-top: 10px;margin-bottom: 10px">{{$t('estimate.uploadTips')}}</div>
            <el-upload
                    class="upload-demo"
                    drag multiple
                    ref="estimatePicBatchUpload"
                    accept=".zip"
                    :on-success="batchUploadSuccess"
                    action=""
                    :limit="5"
                    :http-request="handlePictureBatchUpload"
                    :file-list="filePicList"
                    :auto-upload="false">
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">{{$t('common.dragUploadTips1')}}<em>{{$t('common.dragUploadTips2')}}</em></div>
            </el-upload>
            <el-button style="margin-left: 10px;margin-top: 10px" size="small" type="warning" icon="el-icon-refresh"
                       @click="resetFileList">{{$t('common.resetButton')}}</el-button>
            <el-button style="margin-left: 10px;margin-top: 10px" size="small" type="success" icon="el-icon-upload2"
                       @click="batchUploadFile">{{$t('estimate.uploadFiles')}}</el-button>
            <el-popover
                    placement="bottom"
                    :title="$t('estimate.picBatchUploadTips1')"
                    width="290"
                    trigger="click">
                <img src="../../../assets/image/estimatePicBatchUploadTips.jpg" alt="">
                <el-button slot="reference" type="text" size="mini">
                <el-link type="primary" style="font-size: 12px" icon="el-icon-info">{{$t('estimate.picUploadTips1')}}</el-link>
            </el-button>
            </el-popover>
        </el-dialog>

        <!--修妥图片批量上传弹框-->
        <el-dialog
                :visible.sync="completePicturesBatchUploadShow"
                width="400px" top="5%"
                :before-close="handleClose">
            <div slot="title" class="flex flex-align">
                <i class="el-icon-upload">{{$t('estimate.completePicBatchUpload')}}</i>
            </div>
            <div class="el-upload__tip" style="color:#BC1920;margin-top: 10px;margin-bottom: 10px">{{$t('estimate.picBatchUploadTips')}}</div>
            <div class="el-upload__tip" style="color:#BC1920;margin-top: 10px;margin-bottom: 10px">{{$t('estimate.uploadTips')}}</div>
            <el-upload
                    class="upload-demo"
                    drag multiple
                    ref="completePicBatchUpload"
                    accept=".zip"
                    :on-success="batchUploadSuccess"
                    action=""
                    :limit="5"
                    :http-request="handleCompletePictureBatchUpload"
                    :file-list="filePicList"
                    :auto-upload="false">
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">{{$t('common.dragUploadTips1')}}<em>{{$t('common.dragUploadTips2')}}</em></div>
            </el-upload>
            <el-button style="margin-left: 10px;margin-top: 10px" size="small" type="warning" icon="el-icon-refresh"
                       @click="resetFileList">{{$t('common.resetButton')}}</el-button>
            <el-button style="margin-left: 10px;margin-top: 10px" size="small" type="success" icon="el-icon-upload2"
                       @click="batchUploadFile2">{{$t('estimate.uploadFiles')}}</el-button>
            <el-popover
                    placement="bottom"
                    :title="$t('estimate.picBatchUploadTips1')"
                    width="290"
                    trigger="click">
                <img src="../../../assets/image/estimatePicBatchUploadTips.jpg" alt="">
                <el-button slot="reference" type="text" size="mini">
                <el-link type="primary" style="font-size: 12px" icon="el-icon-info">{{$t('estimate.picUploadTips1')}}</el-link>
            </el-button>
            </el-popover>
        </el-dialog>

        <!--修箱完成弹出框-->
        <el-dialog
                :visible.sync="batchFinishShow"
                width="800px" top="5%">
            <div slot="title" class="flex flex-align">
                <i class="el-icon-s-claim">{{$t('estimate.batchFinish')}}</i>
            </div>
            <div class="el-upload__tip" style="color:#BC1920;margin-top: 10px;margin-bottom: 10px">
                {{$t('estimate.batchFinishNote')}}
            </div>
            <!--勾选估价单-->
            <el-table :data="tableEstimateDataChecked" style="width:100%;margin-top:10px"
                      :key="randomKey" :row-class-name="rowClassName"
                      :header-cell-style="{background:'#E9E9E9',height:'36px',padding:0}"
                      :row-style="{height:'35px'}" :cell-style="{padding:'0px'}"
                      max-height="250" highlight-current-row
                      :empty-text="$t('common.noData')"
                      @cell-dblclick="editData">
                <!--序号-->
                <el-table-column min-width="50" show-overflow-tooltip type="index"
                                 :label="this.$t('estimateDetails.estContainerPic.index')" align="center"/>
                <!--箱号-->
                <el-table-column min-width="80" prop="containerNo"
                                 :label="$t('estimate.containerNo')"
                                 align="center"></el-table-column>
                <!--审核日期-->
                <el-table-column min-width="120" prop="approveDate"
                                 :label="$t('estimate.approveDate')"
                                 align="center"></el-table-column>
                <!--实际完成日期-->
                <el-table-column min-width="120" prop="receiveDate"
                                 :label="$t('estimate.factFinalDate')"
                                 align="center">
                    <template slot-scope="scope">
                        <el-date-picker
                                v-if="scope.row[scope.column.property + scope.row.index + 'isShow']"
                                :ref="scope.column.property" type="date" class="dateInput" clearable
                                v-model="scope.row.factFinalDate" value-format="yyyy-MM-dd" size="small"
                                @blur="alterData(scope.row,scope.column)">
                        </el-date-picker>
                        <span v-else>{{ scope.row.factFinalDate }}</span>
                    </template>
                </el-table-column>
                <!--备注-->
                <el-table-column min-width="160" prop="remark"
                                 :label="$t('estimate.remark')"
                                 align="center">
                    <template slot-scope="scope">
                        <el-input
                                v-if="scope.row[scope.column.property + scope.row.index + 'isShow']"
                                :ref="scope.column.property"
                                v-model="scope.row.remark" size="small"
                                @blur="alterData(scope.row,scope.column)">
                        </el-input>
                        <span v-else>{{ scope.row.remark }}</span>
                    </template>
                </el-table-column>
            </el-table>
            <div class="flex flex-space-around" style="margin-top: 25px">
                <!--实际完成日期-->
                <div class="inputName">
                                <span class="inputName-title">
                                    {{$t('estimate.factFinalDate')}}
                                </span>
                    <el-date-picker v-model="finishAction.factFinalDate" type="date" class="dateInput"
                                    :placeholder="$t('common.pleaseSelectDate')" clearable/>
                </div>
                <!--备注-->
                <div class="inputName">
                                <span class="inputName-title">
                                    {{$t('estimate.remark')}}
                                </span>
                    <el-input v-model="finishAction.remark"
                              :placeholder="$t('common.pleaseEnter')"/>
                </div>
            </div>
            <div style="margin-top: 10px; text-align: center">
                <el-button style="margin-left: 10px;margin-top: 10px" size="small" type="success" icon="el-icon-finished"
                    @click="finishBtnClick">
                    {{repairFinishButton}}</el-button>
                <el-button style="margin-left: 10px;margin-top: 10px" size="small" type="warning" icon="el-icon-close"
                    @click="finishClose">
                    {{closeButton}}</el-button>
            </div>
        </el-dialog>

        <!--页面底部组件-->
        <div class="footerSpan">
            <span></span>
        </div>
    </div>
</template>

<script>
    import noDataView from "@/components/noDataView";
    import resultBar from "@/components/resultBar";

    export default {
        name: "estimate",
        computed: {
            // 估价单号查询条件
            estimateNo: {
                get: function () {
                    return this.search.estimateNo;
                },
                set: function (val) {
                    this.search.estimateNo = val.toUpperCase();
                }
            },
            // 箱号查询条件
            containerNo: {
                get: function () {
                    return this.search.containerNo;
                },
                set: function (val) {
                    this.search.containerNo = val.toUpperCase();
                }
            },
            exportDataButton() {
                return this.$t('common.exportTableData');
            },
            detailButton() {
                return this.$t('common.detail')
            },
            viewDetails() {
                return this.$t('common.viewDetails');
            },
            searchButton() {//查询按钮
                return this.$t("common.searchButton");
            },
            resetButton() {//重置按钮
                return this.$t("common.resetButton");
            },
            editButton() {//编辑按钮
                return this.$t("common.editButton");
            },
            findButton() {//搜索按钮
                return this.$t("common.findButton");
            },
            closeButton() {//关闭按钮
                return this.$t("common.closeButton");
            },
            confirmButton() {//确认按钮
                return this.$t("common.confirmButton");
            },
            repairFinishButton() {//修箱完成
                return this.$t("estimate.repairFinishButton");
            },
            selectAll() {//全选
                return this.$t("common.selectAll");
            },
            selectInverse() {//反选
                return this.$t("common.selectInverse");
            },
        },
        components: {
            noDataView,
            resultBar
        },
        data() {
            return {
                isSearchClick: false,       //控制查询按钮是否重复点击
                isDownloadClick: false,     //控制SO下载按钮是否重复点击
                isPLDownloadClick: false,     //控制PL下载按钮是否重复点击
                isSendClick: false,         //控制发送船公司按钮是否重复点击
                isVVLSearchClick: false,    //控制VVL查询按钮是否重复点击
                estimateUploadShow: false,  //控制估价单excel上传框是否显示
                estimatePicturesBatchUploadShow: false,  //控制箱损图片批量上传框是否显示
                completePicturesBatchUploadShow: false,  //控制修妥图片批量上传框是否显示
                batchFinishShow: false,       //控制修箱完成谈款是否显示
                showViewFlag: "card",       //控制数据是否展开显示 card：卡片  table：表格

                // 待上传文件列表
                fileList: [],// 估价单上传
                filePicList: [],//修箱图片批量上传
                //查询参数
                search: {
                    estimateNo: "",         //估价单号
                    containerNo: "",        //箱号
                    applyDateStart: "",     //申请日期从
                    applyDateEnd: "",       //申请日期到
                    factFinalDateStart: "", //完成日期从
                    factFinalDateEnd: "",   //完成日期到
                    repairStatus: "",       //维修状态
                },
                repairStatusOptions: [      //维修状态下拉值
                    {codeValue: "Applying", displayValueCn: "申请中", displayValue: "APPLYING"},
                    {codeValue: "Approved", displayValueCn: "已审批", displayValue: "APPROVED"},
                    {codeValue: "Rejected", displayValueCn: "已拒绝", displayValue: "REJECTED"},
                    {codeValue: "Finished", displayValueCn: "修箱完成", displayValue: "REPAIR FINISHED"},
                    {codeValue: "FinishApprove", displayValueCn: "完成审核", displayValue: "FINISH APPROVED"},
                    {codeValue: "FinishReject", displayValueCn: "完成拒绝", displayValue: "FINISH REJECTED"}
                ],
                // 修箱完成
                finishAction: {
                    factFinalDate: null,    // 实际完成日期
                    remark: ""              // 备注
                },
                showNoDataView: false,
                tableEstimateData: [],      // 估价单查询结果
                tableEstimateDataChecked: [],   //勾选估价单列表
                pageCount: 5,
                pageNum: 1,
                pageSize: 20,
                total: 0,
                popTableSelection: [],  //存放vvl弹框中鼠标点击选中的值
                bkTableSelection: [],  //存放订舱表格中勾选的订舱记录
                fileImport : new FormData(),
                filePicBatchImport: new FormData(),
                uploadValidate: true,   // 上传校验通过标志
                newEstimateUploadFlag: 0,   // 估价单上传新旧功能标志（0：旧估价单上传 | 1：新估价单上传）
                randomKey: Math.random(),

                tableToolbar: {
                    perfect: true,
                    zoom: true,
                    custom: true,
                    slots: {
                        buttons: 'toolbar_buttons'
                    }
                },

                tableColumn: [
                    { align: 'center' ,type: 'checkbox', width: 40 },
                    { align: 'center' ,type: 'seq', title: 'booking.no', width: 60, sortable: true, },//序号
                    { align: 'center' ,field: 'repairStatus', title: 'estimate.repairStatus', minWidth: 120, sortable: true,
                        slots: {   //该处展示自定义插槽，可以将数据封装到想用的组件里，视觉效果更佳
                            default: 'column_repairStatus'
                        }
                    },// 维修状态
                    { align: 'center' ,field: 'estimateNo', title: 'estimate.estimateNo', minWidth: 120, sortable: true,
                        slots: {
                            default: 'column_estimateNo'
                        }
                    },//估价单号
                    { align: 'center' ,field: 'portCode', title: 'estimate.portCode', minWidth: 80, visible: false},//港口
                    { align: 'center' ,field: 'depotCode', title: 'estimate.depotCode', minWidth: 80, visible: false},//堆场
                    { align: 'center' , title: 'estimate.portAndDepot', minWidth: 120, sortable: true,
                        slots: {
                            default: 'column_portAndDepot'
                        }
                    },//港口/堆场
                    { align: 'center' ,field: 'applyDate', title: 'estimate.applyDate', minWidth: 110, sortable: true, },//申请日期
                    { align: 'center' ,field: 'currency', title: 'estimate.currency', minWidth: 100, sortable: true, },//币种
                    { align: 'center' ,field: 'containerNo', title: 'estimate.containerNo', minWidth: 130, sortable: true,
                        slots: {   //该处展示自定义插槽，可以将数据封装到想用的组件里，视觉效果更佳
                            default: 'column_containerNo'
                        }
                    },//箱号
                    { align: 'center' ,field: 'containerType', title: 'estimate.containerType', minWidth: 140, sortable: true,
                        slots: {
                            default: 'column_containerType'
                        }
                    },//箱型
                    { align: 'center' ,field: 'picStatus', title: 'estimate.picStatus', minWidth: 180, sortable: true,
                        slots: {
                            default: 'column_picStatus'
                        }
                    },//箱损图片导入状态
                    { align: 'center' ,field: 'completePicStatus', title: 'estimate.completePicStatus', minWidth: 180 , sortable: true,
                        slots: {
                            default: 'column_completePicStatus'
                        }
                    },//修妥图片导入状态
                    { align: 'center' ,field: 'vesselCode', title: 'estimate.vesselCode', minWidth: 80, visible: false},//船名
                    { align: 'center' ,field: 'voyageNo', title: 'estimate.voyageNo', minWidth: 80, visible: false},//航次
                    { align: 'center' , title: 'estimate.vvl', minWidth: 150, sortable: true,
                        slots: {   //该处展示自定义插槽，可以将数据封装到想用的组件里，视觉效果更佳
                            default: 'column_vvl'
                        }
                    },//船名/航次
                    { align: 'center' ,field: 'blNo', title: 'estimate.blNo', minWidth: 180, sortable: true,  },//提单号
                    { align: 'center' ,field: 'approveDate', title: 'estimate.approveDate', minWidth: 130, sortable: true,  },//审核日期
                    { align: 'center' ,field: 'factFinalDate', title: 'estimate.factFinalDate', minWidth: 130 },//实际完成日期
                    { align: 'center' ,field: 'menu', title: 'common.menuColumn', minWidth: 80, fixed: 'right',
                        titlePrefix: {
                            icon: 'el-icon-s-tools'
                        },
                        slots: {
                            default: 'operate_default'
                        }
                    }
                ]
            };
        },
        methods: {
            /**
             * 估价单数据表格勾选事件，将表格中选中估价单数据添加进勾选列表中
             */
            handleTableDataChecked({checked}) {
                // 清空数据checked状态
                this.tableEstimateData.forEach((item)=>{
                    item.checked = false;
                });
                // 先清空估价单数据多选列表
                this.tableEstimateDataChecked = [];
                const records = this.$refs.tableEstimateData.getCheckboxRecords();
                // 更新卡片视图下数据选中状态
                records.forEach((item)=>{
                    item.checked = true;
                });
                // 更新表格勾选的估价单信息
                this.tableEstimateDataChecked = records;
            },
            /**
             * 表格数据导出
             */
            exportDataEvent () {
                this.$refs.tableEstimateData.openExport({ types: ['csv'] })
            },
            rowClassName({row, rowIndex}) {
                //把每一行的索引放进row
                row.index = rowIndex;
            },
            editData(row, column) {
                row[column.property + row.index + "isShow"] = true;
                //refreshTable是table数据改动时，刷新table的
                this.refreshTable();
                this.$nextTick(() => {
                    this.$refs[column.property] && this.$refs[column.property].focus()
                })
            },
            alterData(row, column) {
                row[column.property + row.index + "isShow"] = false;
                this.refreshTable()
            },
            refreshTable() {
                this.randomKey = Math.random()
            },
            checkAllBtnClick(isCheck){
                this.tableEstimateDataChecked = [];
                if(isCheck){
                    // 全选
                    this.tableEstimateData.forEach((item,index)=>{
                        item.checked = true;
                        this.checkOneMethod(index, true)
                    })
                }else{
                    // 反选
                    this.tableEstimateData.forEach((item,index)=>{
                        let cur = item.checked;
                        item.checked = !cur;
                        this.checkOneMethod(index, !cur)
                    })
                }
            },
            /**
             * 估价单记录勾选事件，将选中估价单添加进勾选列表中
             */
            checkOneMethod(index, type) {
                let curData = this.tableEstimateData[index];
                if (type) {//选中
                    this.tableEstimateDataChecked.push(curData);
                    // 新增表格视图下全选控制
                    if(this.$refs.tableEstimateData){
                        this.$refs.tableEstimateData.setCheckboxRow(curData, type);
                    }
                } else {//取消选中
                    this.tableEstimateDataChecked.forEach((item, index) => {
                        if (item.estimateId === curData.estimateId) {
                            this.tableEstimateDataChecked.splice(index, 1);
                        }
                    })
                    // 新增表格视图下反选控制
                    if(this.$refs.tableEstimateData){
                        this.$refs.tableEstimateData.toggleCheckboxRow(curData);
                    }
                }
            },
            // 刷新表格记录选中状态，恢复未选中状态
            refreshChecked(tableData){
                tableData.forEach((data)=>{
                    data.checked = false;
                    // 处理数字格式
                    data.labTotal = this.formatNumber(data.labTotal,2);
                    data.matTotal = this.formatNumber(data.matTotal,2);
                    data.applyTotal = this.formatNumber(data.applyTotal,2);
                    data.approveTotal = this.formatNumber(data.approveTotal,2);
                });
                return tableData;
            },
            /************************************ 按钮点击事件 ***********************************
             * 估价单查询 按钮点击
             */
            searchBtnClick() {
                if (this.isSearchClick) {//上一次查询未结束时不允许重复发起请求
                    return;
                }
                this.isSearchClick = true;

                // 声明一个loading对象
                this.loadingtuo = this.$loading({
                    lock: true, // 设置加载时是否锁屏,锁屏状态加载区域无法操作
                    text: this.$t('message.searching'),     // 加载动画的文字
                    spinner: 'el-icon-loading',             // 引入的loading图标
                    background: "rgb(0,0,0,0.1)",
                    // target: document.querySelector(".searchComposite") // 设置加载动画区域
                });
                let that = this;
                this.axios({
                    method: 'post',
                    url: '/api/equipment/estimateQuery',
                    data: {
                        estimateNo: this.search.estimateNo,
                        containerNo: this.search.containerNo,
                        applyDateStart: this.search.applyDateStart === "" ? "" : this.formatDate(
                            {date: this.search.applyDateStart, formatStr: 'yyyy-MM-dd'}
                        ),
                        applyDateEnd: this.search.applyDateEnd === "" ? "" : this.formatDate(
                            {date: this.search.applyDateEnd, formatStr: 'yyyy-MM-dd'}
                        ),
                        factFinalDateStart: this.search.factFinalDateStart === "" ? "" : this.formatDate(
                            {date: this.search.factFinalDateStart, formatStr: 'yyyy-MM-dd'}
                        ),
                        factFinalDateEnd: this.search.factFinalDateEnd === "" ? "" : this.formatDate(
                            {date: this.search.factFinalDateEnd, formatStr: 'yyyy-MM-dd'}
                        ),
                        repairStatus: this.search.repairStatus,
                        pageNum: this.pageNum,
                        pageSize: this.pageSize
                    },
                    headers: {
                        'Accept-language': localStorage.getItem("locale")
                    }
                }).then(response => {
                    that.loadingtuo.close();
                    this.responseCode = response.data.backMessage;
                    if (response.data.backCode === "200") {
                        this.showNoDataView = false;//请求成功,无数据组件隐藏,显示估价单数据表格
                        this.tableEstimateData = this.refreshChecked(response.data.object.list);
                        this.total = response.data.object.total;
                    } else {
                        this.showMessage(false, this.responseCode, "error");
                        // 当前未登录，跳转到登录页面
                        this.$router.push({
                            path: '/homePage',
                            query: {redirect: "/estimate"} // 将跳转的路由path作为参数，登录成功后跳转到该路由
                        });
                    }
                    this.isSearchClick = false;//设置查询按钮为可点击状态,允许再次发起请求
                }).catch(error => {
                    that.loadingtuo.close();//关闭进度条
                    if (error.data) {
                        this.responseCode = error.data.backMessage;
                        this.showMessage(false, this.responseCode, "error");
                    } else {
                        this.showMessage(false, error, "error");
                    }
                    this.isSearchClick = false;//设置查询按钮为可点击状态,允许再次发起请求
                });
                // 每次查询后清空勾选估价单记录
                this.tableEstimateDataChecked = [];
            },
            resetBtnClick() {//重置按钮点击
                this.search.estimateNo = "";
                this.search.containerNo = "";
                this.search.applyDateStart = "";
                this.search.applyDateEnd = "";
                this.search.factFinalDateStart = "";
                this.search.factFinalDateEnd = "";
                this.search.repairStatus = "";
            },
            editBtnClick(estimate) {//编辑按钮点击事件,将选中估价单数据传递到估价单明细页面
                this.axios({
                    method: 'post',
                    url: '/api/equipment/estimateDetailsQuery/'+estimate.estimateId,
                    data: {
                        estimateId: estimate.estimateId
                    },
                    headers: {
                        'Accept-language': localStorage.getItem("locale")
                    }
                }).then(response => {
                    this.responseCode = response.data.backMessage;
                    if (response.data.backCode === "200") {
                        if (response.data.object != null) {
                            // this.$router.push({
                            //     name: 'estimate/estimateDetails',
                            //     params: {
                            //         estimateInfo: response.data.object
                            //     }
                            // });
                            var route = this.$router.resolve({
                                name: 'estimate/estimateDetails',
                            });
                            let estimateInfo = response.data.object;
                            // 将传递参数存到session中
                            sessionStorage.setItem("PASSING_PARAMETERS", JSON.stringify(estimateInfo));
                            // 打开估价单详情页面
                            window.open(route.href, '_blank')
                        }
                    } else {
                        this.showMessage(false, this.responseCode, "error");
                        // 当前未登录，跳转到登录页面
                        this.$router.push({
                            path: '/homePage',
                            query: {redirect: "/estimate"} // 将跳转的路由path作为参数，登录成功后跳转到该路由
                        });
                    }
                }).catch(error => {
                    if (error.data) {
                        this.responseCode = error.data.backMessage;
                        this.showMessage(false, this.responseCode, "error");
                    } else {
                        this.showMessage(false, error, "error");
                    }
                });
            },
            /**
             * 修箱估价单导入
             */
            estimateExcelImport(){
                this.newEstimateUploadFlag = 0;
                this.estimateUploadShow = true;
                this.uploadValidate = true;
            },
            /**
             * 修箱估价单导入(新)
             */
            estimateExcelImportNew(){
                this.newEstimateUploadFlag = 1;
                this.estimateUploadShow = true;
                this.uploadValidate = true;
            },
            /**
             * 箱损图片批量导入
             */
            estimatePicturesBatchImport(){
                this.estimatePicturesBatchUploadShow = true;
                this.uploadValidate = true;
            },
            /**
             * 修妥图片批量导入
             */
            completedPicturesBatchImport(){
                this.completePicturesBatchUploadShow = true;
                this.uploadValidate = true;
            },
            /**
             * 【修箱估价单导入】上传文件
             */
            uploadFile(){
                this.fileImport = new FormData();
                this.$refs.estimatesUpload.submit();
                this.$refs.estimatePicturesUpload.submit();
                let requestURL = "/api/equipment/estimatesUpload";
                if (this.newEstimateUploadFlag === 1) {
                    requestURL = "/api/equipment/estimatesUploadNew";
                }

                if(!this.uploadValidate){
                    return;
                }

                // 上传确认
                this.$confirm(this.$t("common.uploadConfirm"), this.$t("common.pleaseConfirm"), {
                    distinguishCancelAndClose: true,
                    confirmButtonText: this.$t("common.confirmButton"),
                    cancelButtonText: this.$t("common.cancelButton")
                }).then(() => {
                    if(this.fileImport.entries().next().value){
                        // 启动进度条
                        this.loadingOverLay = this.$loading({
                            lock: false,
                            text: this.$t('estimate.uploading'),
                            spinner: 'el-icon-loading',
                            background: 'rgba(0,0,0,0.1)'
                        });
                        // 实现估价单和图片文件同时上传
                        this.axios.post(requestURL, this.fileImport, {
                            headers: {'Content-Type': 'multipart/form-data','Accept-language': localStorage.getItem("locale")},
                            timeout: 200000,
                        }).then(response => {
                            // // 清空待上传附件列表
                            // this.fileList = [];
                            this.responseCode = response.data.backMessage;
                            if (response.data.backCode === "407") {
                                // 未上传估价单
                                this.showMessage(false, this.responseCode, "warning");
                            } else if (response.data.backCode === "200") {
                                this.$alert(this.responseCode.replaceAll(';',' <br/> '), this.$t('estimate.uploadCompleted'), {
                                    customClass: 'uploadMsg',
                                    confirmButtonText: this.$t('common.okButton'),
                                    dangerouslyUseHTMLString: true
                                });
                            } else {
                                this.$alert(this.responseCode.replaceAll(';',' <br/> '), this.$t('estimate.uploadCompleted'), {
                                    customClass: 'uploadMsg',
                                    confirmButtonText: this.$t('common.okButton'),
                                    dangerouslyUseHTMLString: true
                                });
                            }
                            this.loadingOverLay.close();
                        }).catch(error => {
                            if (error.data) {
                                this.responseCode = error.data.backMessage;
                                this.$alert(this.responseCode.replaceAll(';',' <br/> '), this.$t('estimate.uploadCompleted'), {
                                    customClass: 'uploadMsg',
                                    confirmButtonText: this.$t('common.okButton'),
                                    dangerouslyUseHTMLString: true
                                });
                            } else {
                                this.showMessage(false, error, "error");
                            }
                            this.loadingOverLay.close();
                        });
                        // 上传完毕，清空文件存储列表
                        this.fileImport = new FormData();
                    }else{
                        this.showMessage(false, this.$t('estimate.pleaseSelectFiles2Upload'), "warning");
                    }
                });
            },
            /**
             * 【箱损图片批量导入】上传文件
             */
            batchUploadFile(){
                this.filePicBatchImport = new FormData();
                this.$refs.estimatePicBatchUpload.submit();

                if(!this.uploadValidate){
                    return;
                }

                // 上传确认
                this.$confirm(this.$t("common.uploadConfirm"), this.$t("common.pleaseConfirm"), {
                    distinguishCancelAndClose: true,
                    confirmButtonText: this.$t("common.confirmButton"),
                    cancelButtonText: this.$t("common.cancelButton")
                }).then(() => {
                    // 当filePicBatchImport中有获取到待上传文件时才发出请求
                    if(!!this.filePicBatchImport.entries().next().value) {
                        // 启动进度条
                        this.loadingOverLay = this.$loading({
                            lock: false,
                            text: this.$t('estimate.uploading'),
                            spinner: 'el-icon-loading',
                            background: 'rgba(0,0,0,0.1)'
                        });
                        // 实现估价单和图片文件同时上传
                        this.axios.post('/api/equipment/estimatePicturesUpload', this.filePicBatchImport, {
                            headers: {'Content-Type': 'multipart/form-data','Accept-language': localStorage.getItem("locale")},
                            onUploadProgress: (progressEvent)=>{
                                this.percent = Number(
                                    ((progressEvent.loaded / progressEvent.total)*100).toFixed(0)
                                )
                            },
                            timeout: 200000,
                        }).then(response => {
                            this.responseCode = response.data.backMessage;
                            if (response.data.backCode === "200") {
                                this.$alert(this.responseCode.replaceAll(';',' <br/> '), this.$t('estimate.uploadCompleted'), {
                                    customClass: 'uploadMsg',
                                    confirmButtonText: this.$t('common.okButton'),
                                    dangerouslyUseHTMLString: true
                                });
                            } else {
                                this.$alert(this.responseCode.replaceAll(';',' <br/> '), this.$t('estimate.uploadCompleted'), {
                                    customClass: 'uploadMsg',
                                    confirmButtonText: this.$t('common.okButton'),
                                    dangerouslyUseHTMLString: true
                                });
                            }
                            this.loadingOverLay.close();
                        }).catch(error => {
                            if (error.data) {
                                this.responseCode = error.data.backMessage;
                                this.$alert(this.responseCode.replaceAll(';',' <br/> '), this.$t('estimate.uploadCompleted'), {
                                    customClass: 'uploadMsg',
                                    confirmButtonText: this.$t('common.okButton'),
                                    dangerouslyUseHTMLString: true
                                });
                            } else {
                                this.showMessage(false, error, "error");
                            }
                            this.loadingOverLay.close();
                        });
                        // 上传完毕，清空文件存储列表
                        this.filePicBatchImport = new FormData();
                    }else{
                        this.showMessage(false, this.$t('estimate.pleaseSelectFiles2Upload'), "warning");
                    }
                });
            },
            /**
             * 【修妥图片批量导入】上传文件
             */
            batchUploadFile2(){
                this.filePicBatchImport = new FormData();
                this.$refs.completePicBatchUpload.submit();

                if(!this.uploadValidate){
                    return;
                }

                // 上传确认
                this.$confirm(this.$t("common.uploadConfirm"), this.$t("common.pleaseConfirm"), {
                    distinguishCancelAndClose: true,
                    confirmButtonText: this.$t("common.confirmButton"),
                    cancelButtonText: this.$t("common.cancelButton")
                }).then(() => {
                    // 当filePicBatchImport中有获取到待上传文件时才发出请求
                    if(!!this.filePicBatchImport.entries().next().value) {
                        // 启动进度条
                        this.loadingOverLay = this.$loading({
                            lock: false,
                            text: this.$t('estimate.uploading'),
                            spinner: 'el-icon-loading',
                            background: 'rgba(0,0,0,0.1)'
                        });
                        // 实现估价单和图片文件同时上传
                        this.axios.post('/api/equipment/completePicturesUpload', this.filePicBatchImport, {
                            headers: {'Content-Type': 'multipart/form-data','Accept-language': localStorage.getItem("locale")},
                            onUploadProgress: (progressEvent)=>{
                                this.percent = Number(
                                    ((progressEvent.loaded / progressEvent.total)*100).toFixed(0)
                                )
                            },
                            timeout: 200000,
                        }).then(response => {
                            this.responseCode = response.data.backMessage;
                            if (response.data.backCode === "200") {
                                this.$alert(this.responseCode.replaceAll(';',' <br/> '), this.$t('estimate.uploadCompleted'), {
                                    customClass: 'uploadMsg',
                                    confirmButtonText: this.$t('common.okButton'),
                                    dangerouslyUseHTMLString: true
                                });
                            } else {
                                this.$alert(this.responseCode.replaceAll(';',' <br/> '), this.$t('estimate.uploadCompleted'), {
                                    customClass: 'uploadMsg',
                                    confirmButtonText: this.$t('common.okButton'),
                                    dangerouslyUseHTMLString: true
                                });
                            }
                            this.loadingOverLay.close();
                        }).catch(error => {
                            if (error.data) {
                                this.responseCode = error.data.backMessage;
                                this.$alert(this.responseCode.replaceAll(';',' <br/> '), this.$t('estimate.uploadCompleted'), {
                                    customClass: 'uploadMsg',
                                    confirmButtonText: this.$t('common.okButton'),
                                    dangerouslyUseHTMLString: true
                                });
                            } else {
                                this.showMessage(false, error, "error");
                            }
                            this.loadingOverLay.close();
                        });
                        // 上传完毕，清空文件存储列表
                        this.filePicBatchImport = new FormData();
                    }else{
                        this.showMessage(false, this.$t('estimate.pleaseSelectFiles2Upload'), "warning");
                    }
                });
            },
            // 估价单上传自定义方法
            handleUpload(param){
                // 校验文件格式
                let reg = /(?<=\.)[a-z]+$/g;
                let fileType = param.file.name.match(reg)+"";
                let typeArr = ["xls","xlsx"];
                if(!typeArr.includes(fileType)){
                    this.$message.warning(this.$t('estimate.wrongEstimateFormat'));
                    this.uploadValidate = false;
                    return;
                }

                // 校验文件大小
                let fileSize = this.formatNumber(param.file.size / 1024 / 1024, 2);
                const isLt20M = fileSize < 20;
                if(!isLt20M){
                    this.$message.warning(this.$t('estimate.uploadSizeLimit',{fileName: param.file.name, fileSize : (fileSize+'M')}));
                    this.uploadValidate = false;
                    return;
                }

                this.fileImport.append('file',param.file);
            },
            // 修箱图片上传自定义方法
            handlePictureUpload(param){
                // 校验文件格式
                let reg = /(?<=\.)[a-z]+$/g;
                let fileType = param.file.name.match(reg)+"";
                let typeArr = ["zip"];
                if(!typeArr.includes(fileType)){
                    this.$message.warning(this.$t('estimate.wrongPicFormat'));
                    this.uploadValidate = false;
                    return;
                }

                // 校验文件大小
                let fileSize = this.formatNumber(param.file.size / 1024 / 1024, 2);
                const isLt20M = fileSize < 20;
                if(!isLt20M){
                    this.$message.warning(this.$t('estimate.uploadSizeLimit',{fileName: param.file.name, fileSize : (fileSize+'M')}));
                    this.uploadValidate = false;
                    return;
                }

                this.fileImport.append('file',param.file);
            },
            // 箱损图片批量上传自定义方法
            handlePictureBatchUpload(param){
                // 校验文件格式
                let reg = /(?<=\.)[a-z]+$/g;
                let fileType = param.file.name.match(reg)+"";
                let typeArr = ["zip"];
                if(!typeArr.includes(fileType)){
                    this.$message.warning(this.$t('estimate.wrongPicFormat'));
                    this.uploadValidate = false;
                    return;
                }

                // 校验文件大小
                let fileSize = this.formatNumber(param.file.size / 1024 / 1024, 2);
                const isLt20M = fileSize < 20;
                if(!isLt20M){
                    this.$message.warning(this.$t('estimate.uploadSizeLimit',{fileName: param.file.name, fileSize : (fileSize+'M')}));
                    this.uploadValidate = false;
                    return;
                }

                this.filePicBatchImport.append('file',param.file);
            },
            // 修妥图片批量上传自定义方法
            handleCompletePictureBatchUpload(param){
                // 校验文件格式
                let reg = /(?<=\.)[a-z]+$/g;
                let fileType = param.file.name.match(reg)+"";
                let typeArr = ["zip"];
                if(!typeArr.includes(fileType)){
                    this.$message.warning(this.$t('estimate.wrongPicFormat'));
                    this.uploadValidate = false;
                    return;
                }

                // 校验文件大小
                let fileSize = this.formatNumber(param.file.size / 1024 / 1024, 2);
                const isLt20M = fileSize < 20;
                if(!isLt20M){
                    this.$message.warning(this.$t('estimate.uploadSizeLimit',{fileName: param.file.name, fileSize : (fileSize+'M')}));
                    this.uploadValidate = false;
                    return;
                }

                this.filePicBatchImport.append('file',param.file);
            },
            /*
             *上传成功-回调函数
             */
            uploadSuccess(res, file, fileList){
                // 清除上传文件列表
                this.$refs.estimatesUpload.clearFiles();
                this.$refs.estimatePicturesUpload.clearFiles();
            },
            /**
             * 清空已上传文件
             */
            resetFileList(){
                this.fileList = [];
                this.filePicList = [];
            },
            /**
             * 批量上传成功-回调函数
             */
            batchUploadSuccess(res, file, fileList){
                // 清除上传文件列表
                this.$refs.estimatePicBatchUpload.clearFiles();
                this.$refs.completePicBatchUpload.clearFiles();
            },
            /**
             * 上传弹框关闭事件
             */
            handleClose(done){
                // 弹框关闭前，清空待上传文件列表
                this.fileList = [];
                this.filePicList = [];
                done();
            },

            /************************************ 分页条 ************************************
             * 估价单数据表格分页条
             */
            handleDemand() {
                this.searchBtnClick();
            },
            handleSizeChange(val) {
                this.pageSize = val;
                this.handleDemand();
                this.$emit("backTop");
            },
            handleCurrentChange(val) {
                this.pageNum = val;
                this.handleDemand(1);
                this.$emit("backTop");
            },
            /**
             * 订舱数据表格分页条(表格视图)
             */
            handleTablePageChange ({ currentPage, pageSize }) {
                this.pageNum = currentPage;
                this.pageSize = pageSize;
                this.searchBtnClick();
            },

            /************************************ 修箱完成 ************************************/
            /**
             * 修箱完成
             */
            finishedAction(){
                let errorMsg = [];
                if(this.tableEstimateDataChecked.length > 0){
                    this.tableEstimateDataChecked.forEach((checkedItem)=>{
                        // 校验选中记录维修状态，只有已审批的估价单可以设置修箱完成
                        if(checkedItem.repairStatus !== "Approved"){
                            errorMsg.push(this.$t('estimate.failed2finish',{estimateNo:checkedItem.estimateNo}));
                        }
                        // 校验选中记录修妥图片上传状态，修妥图片已上传才可以设置修箱完成
                        if(checkedItem.completePicStatus !== 'Y'){
                            errorMsg.push(this.$t('estimate.failed2finish2',{containerNo:checkedItem.containerNo}));
                        }
                    });
                    if(errorMsg.length > 0){
                        this.$message({
                            dangerouslyUseHTMLString: true,
                            message: errorMsg.join(' <br/><br/> '),
                            type: 'error'
                        });
                        return;
                    }
                    this.finishAction.factFinalDate = "";
                    this.finishAction.remark = "";
                    this.batchFinishShow = true;
                }else{
                    this.showMessage(false, this.$t('message.pleaseSelect2operate'), "warning");
                }
            },
            finishBtnClick(){
                let finishData = [];
                let confirmData = [];
                let customFinishData = [];//自定义修箱完成
                let errorMsg = [];
                if(this.tableEstimateDataChecked.length > 0){
                    let flag = false;// 是否存在表格中未填写实际完成日期的情况
                    this.tableEstimateDataChecked.forEach((item)=>{
                        if(item.factFinalDate == null
                            || item.factFinalDate === ""){
                            flag = true;
                            customFinishData.push(item);
                        }
                    });
                    // 是否有表格中未填写实际完成日期的，表格中实际完成日期为空的，校验下方统一完成日期是否为空
                    if(flag
                        && (this.finishAction.factFinalDate == null || this.finishAction.factFinalDate === "")
                        && customFinishData.length > 0){
                            //估价单(箱号={0})，{1}不能为空
                        customFinishData.forEach((item=>{
                            errorMsg.push(this.$t("estimate.finishValidate",
                                {containerNo: item.containerNo, fieldName: this.$t("estimate.factFinalDate")}))
                        }))
                    }

                    if(errorMsg.length > 0){
                        this.$message({
                            dangerouslyUseHTMLString: true,
                            message: errorMsg.join(' <br/><br/> '),
                            type: 'error'
                        });
                        return;
                    }

                    this.tableEstimateDataChecked.forEach((item)=>{
                        // 获取审批日期
                        let approveDate = item.approveDate;
                        // 获取当前记录设置的实际完成日期
                        let factFinalDate = null;
                        if(item.factFinalDate == null || item.factFinalDate === ""){
                            factFinalDate = this.finishAction.factFinalDate;
                        }else{
                            factFinalDate = item.factFinalDate;
                        }

                        // 赋值备注信息
                        if(item.remark == null || item.remark === ""){
                            item.remark = this.finishAction.remark;
                        }
                        // 赋值实际完成日期
                        item.factFinalDate = this.formatDate({date: factFinalDate, formatStr: 'yyyy-MM-dd'});

                        // 校验完成日期是否大于审核日期
                        if(this.compareDate(new Date(factFinalDate), new Date(approveDate)) < 0){
                            errorMsg.push(this.$t("estimate.finishValidate2",{containerNo: item.containerNo}));
                            confirmData.push(item);//放入待确认列表中
                        } else{
                            // 直接保存，加入待完成列表
                            finishData.push(item);//放入待修箱完成列表中
                        }
                    });

                    if(errorMsg.length > 0){
                        this.$confirm(errorMsg.join("\r\n"), this.$t("common.pleaseConfirm"), {
                            distinguishCancelAndClose: true,
                            confirmButtonText: this.$t("common.saveBtn"),
                            cancelButtonText: this.$t("common.cancelButton")
                        }).then(() => {
                            //确认是否保存，加入待完成列表
                            confirmData.forEach((item)=>{
                                finishData.push(item)
                            });
                            if(finishData.length > 0){
                                // 启动进度条
                                this.loadingOverLay = this.$loading({
                                    lock: false,
                                    text: this.$t('common.committing'),
                                    spinner: 'el-icon-loading',
                                    background: 'rgba(0,0,0,0.1)'
                                });
                                this.axios({
                                    method: 'post',
                                    url: '/api/equipment/repairFinish',
                                    data: {finishData: JSON.stringify(finishData)},
                                    headers: {
                                        'Accept-language': localStorage.getItem("locale"),
                                        'Content-type': "application/json;charset=utf-8"
                                    },
                                    timeout: 200000
                                }).then(response => {
                                    this.responseCode = response.data.backMessage;
                                    if (response.data.backCode === "200") {
                                        this.showMessage(false, this.responseCode, "success");
                                    } else {
                                        this.showMessage(false, this.responseCode, "error");
                                        // 当前未登录，跳转到登录页面
                                        this.$router.push({
                                            path: '/homePage',
                                            query: {redirect: "/estimate"} // 将跳转的路由path作为参数，登录成功后跳转到该路由
                                        });
                                    }
                                    this.loadingOverLay.close();
                                }).catch(error => {
                                    if (error.data) {
                                        this.responseCode = error.data.backMessage;
                                        this.showMessage(false, this.responseCode, "error");
                                    } else {
                                        this.showMessage(false, error, "error");
                                    }
                                    this.loadingOverLay.close();
                                });
                            }
                        }).catch(action => {
                            //跳过
                            if (action === 'cancel') {
                                console.log(action);
                            }
                        })
                    } else{
                        // 直接提交
                        confirmData.forEach((item)=>{
                            finishData.push(item)
                        });
                        if(finishData.length > 0){
                            // 启动进度条
                            this.loadingOverLay = this.$loading({
                                lock: false,
                                text: this.$t('common.committing'),
                                spinner: 'el-icon-loading',
                                background: 'rgba(0,0,0,0.1)'
                            });
                            this.axios({
                                method: 'post',
                                url: '/api/equipment/repairFinish',
                                data: {finishData: JSON.stringify(finishData)},
                                headers: {
                                    'Accept-language': localStorage.getItem("locale"),
                                    'Content-type': "application/json;charset=utf-8"
                                },
                                timeout: 200000
                            }).then(response => {
                                this.responseCode = response.data.backMessage;
                                if (response.data.backCode === "200") {
                                    this.showMessage(false, this.responseCode, "success");
                                } else {
                                    this.showMessage(false, this.responseCode, "error");
                                    // 当前未登录，跳转到登录页面
                                    this.$router.push({
                                        path: '/homePage',
                                        query: {redirect: "/estimate"} // 将跳转的路由path作为参数，登录成功后跳转到该路由
                                    });
                                }
                                this.loadingOverLay.close();
                            }).catch(error => {
                                if (error.data) {
                                    this.responseCode = error.data.backMessage;
                                    this.showMessage(false, this.responseCode, "error");
                                } else {
                                    this.showMessage(false, error, "error");
                                }
                                this.loadingOverLay.close();
                            });
                        }
                    }
                }
            },
            // 修箱完成弹框关闭
            finishClose(){
                this.batchFinishShow = false;
            },

            handleViewStyle(data){
                // 切换展示风格
                this.showViewFlag = data.value;
                // 将展示风格存到session中
                localStorage.setItem("VIEW_STYLE",this.showViewFlag);
            },

            formatUpper(parent, prop, value, index) {
                if (value !== "") {
                    switch (parent) {
                        //舱单数据
                        case 'tableEstimateDataChecked':
                            this.tableEstimateDataChecked[prop] = value.toUpperCase();
                            break;
                    }
                }
            },
            formatNumber(number, decimals) {
                if (number !== "") {
                    let formatNumber = "";
                    //去掉非法字符
                    number = (number + '').replace(/[^\d.]/g, '')
                    // 必须保证第一个为数字而不是. 输入第一位为.默认补充0
                        .replace(/^\./g, '0.')
                        // 保证只有出现一个.而没有多个.
                        .replace(/\.{2,}/g, '.')
                        // 保证.只出现一次，而不能出现两次以上
                        .replace('.', '$#$')
                        .replace(/\./g, '')
                        .replace('$#$', '.');
                    let strs = number.split('.');
                    if (strs.length === 1) {
                        formatNumber = strs[0];
                    } else if (strs.length > 1) {
                        strs[1] += "00";
                        if (strs[1].length > decimals) {
                            strs[1] = strs[1].substring(0, decimals);
                        }
                        formatNumber = strs.join('.');
                    }
                    return formatNumber;
                }
            },

            /************************************ 行记录点击事件 ************************************/

            /************************************ 基础数据下拉框赋值 ************************************/

            /************************************ 页面初始化 ************************************/

            /************************************ 接口返回数据国际化显示 *************************************/
            getRepairStatusDisplayValue(item) {
                let value = {};
                this.repairStatusOptions.forEach((option) => {
                    if (option.codeValue == item.repairStatus) {
                        value = option;
                    }
                });
                if (value !== {}) {
                    return localStorage.getItem('locale') == 'en' ? value.displayValue : value.displayValueCn;
                } else {
                    return item.repairStatus;
                }
            },
            getCurLanguage() {
                return localStorage.getItem('locale');
            },
        },
        mounted() {
            // 页面渲染完成后初始化数据展示风格
            if(localStorage.getItem("VIEW_STYLE") != null){
                this.showViewFlag = localStorage.getItem("VIEW_STYLE");
            } else{
                this.showViewFlag = "card";//默认展示卡片视图
            }
        },
        created() {
            this.$parent.updateHeaderAside();
        },
        activated() {
            // //当估价单表格有数据时需自动查询最新数据
            // if (this.tableEstimateData.length > 0) {
            //     this.searchBtnClick();
            // }
        }
    };
</script>
<style lang="scss" scoped>
    @import "../../../assets/scss/base";
    @import "../../../assets/scss/public";

    /*列表展示*/
    .contentListCom{min-height: 264px;}
    .contentListCom .oneContent{width: 100%;margin-bottom: 10px;margin-top: 5px}
    .contentListCom .top{height: 40px;border: 1px solid #E8E8E8;background: #E9E9E9;padding-left: 18px;line-height: 40px;}
    .contentListCom .center{padding: 15px 0 15px 17px;border: 1px solid #E8E8E8;background: #FFFFFF;border-top: none}
    .contentListCom .bottom{height: 40px;border: 1px solid #E8E8E8;background: #FFFFFF;border-top: none;line-height: 40px;}
    .contentListCom .listContentLong{width: 330px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;color: #606266;margin-top: 5px;}
    .contentListCom .listContentShort{width: 200px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;color: #606266;margin-top: 5px;}
    .contentListCom .listContent{width: 270px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;color: #606266;margin-top: 5px;}
    .contentListCom .listContent .thirdSpan{margin-left: 5px;display: inline-block}
    .contentListCom .center .listContent{font-size: 15px;height: 20px;line-height: 20px;}
    .contentListCom .center .listContent .secondSpan{color: #031B28;}
    .contentListCom .center .shortListContent{width: 200px}
    .contentListCom .center .longListContent{width: 300px}
    .contentListCom .listContent.rightMoney{text-align: right;margin-right: 5px}
    /*列表展示的单选和费用明细按钮*/
    .contentListCom .top{position: relative}
    .contentListCom .top .evaluateBtn{margin-left: 10px;border-radius: 4px}
    .contentListCom .top .feeDetail{position: absolute;right: 5px;top: 5px}
    .contentListCom .top .checkOne{margin-right: 5px;margin-top: 5px}
    /*列表展示图标位置*/
    .contentListCom .center{position: relative}
    .typeImg{ width: 160px;height: 125px;position: absolute;right: 10px;top: 6px;}
    .flexDiv{display: flex;flex-wrap: wrap;}
    /*列表展示协议价订单等内容展示*/
    .leftMessage .msg{line-height: 39px;margin-left: 10px;color: #606266;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;}
    .xyj{width: 72px;color: #BC1920!important;}
    .auditMes{max-width: 95px;}
    .documentValid{width: 210px;margin-top: 5px;font-weight: bold}
    .documentValidLong{width: 280px;margin-top: 5px;font-weight: bold}
    .flexDiv .normalListButton{margin-right: 3px;}
    .flexDiv .normalListButton1{margin-right: 3px;margin-top: 2px}
    .flexDiv .normalListBlueButton{margin-right: 3px;background: $colorJ;color: $colorA;border: 1px solid #F6F6F6;}
    .flexDiv .normalListRedButton{margin-right: 3px;background: $colorC;color: $colorA;border: 1px solid #F6F6F6;}
    .hasBack{background-color: #567E8D;color: #fff}
    .hasBack:hover{background-color: #354953!important;color: #fff!important;}

    /*其他常用*/
    .visCom{visibility: hidden}
    .overflow{overflow: hidden}
    .l{float: left}
    .r{float: right}
    .flexDiv{display: flex;flex-wrap: wrap;}

    .jdt_nr {
        width: 50%;
        margin: 0 auto;
        z-index: 10001;
        top: 50%;
        margin-top: -31px;
        text-align: center;
        position: absolute;
        margin-left: 25%
    }

    .inputName {
        flex: 1;
        margin: 0 5px;
    }

    .topMargin {
        margin-top: 20px;
    }

    .searchBtn {
        display: flex;
        flex: 1;
        justify-content: flex-end;
        margin: 0 5px;
    }

    .voyageIcon {
        margin-left: 10px;
        margin-top: 5px;
        width: 30px;
        height: 30px;
        border: 1px solid #0091ff;
        border-radius: 4px;
    }

    .noData {
        height: 100%;
        margin: 15px 0;
        background-color: #ffffff;
    }

    .searchList {
        margin: 15px 0;
    }

    /deep/ .el-input-group__prepend {
        background-color: #d9e3f0;
    }

    .popoverView {
        padding: 5px;
        background-color: #ffffff;
    }

    .popoverInner {
        margin: 5px;
        margin-top: 0;
    }

    .flex1 {
        flex: 1;
    }

    .boatBox {
        position: relative;

        .boatBox-list-box {
            min-width: 280px;
            position: absolute;
            left: 51px;
            top: 30px;
            background: $colorA;
            padding: 5px 10px;
            z-index: 100;
            border: 1px solid $colorE;
            font-size: $fontC;
            font-weight: 600;

            .boatBox-top {
                width: 100%;
                height: 20px;
                line-height: 20px;
                background: $colorB;
            }

            .left {
                width: 30%;
                margin-right: 4%;
            }

            .right {
                width: 66%;
            }

            ul {
                padding: 0;
                margin: 0;

                li {
                    border-bottom: 1px solid #e7f0fc;
                    padding: 4px 2px;
                }

                li:last-of-type {
                    border: none;
                }

                li:hover {
                    background: rgb(224, 240, 245);
                }
            }
        }
    }

    .progress1{ display:none;}
    .progress{
        display: flex;
        width: 80px;
        height: 80px;
        position: absolute;
        top: 40px;
        left: 50%;
        transform: translate(-50%, 0);
        background-color: transparent;
    }

    .cardTitle {
        margin-bottom: 10px;

        span {
            font-size: $fontC;
            color: $colorF;
            letter-spacing: 0;
            font-weight: 600;
            margin-left: 6px;
        }
    }

    .applyingEnImg {
        background-image: url(../../../assets/image/applyingEnImg.jpg) !important;
        background-repeat: no-repeat;
    }
    .applyingImg {
        background-image: url(../../../assets/image/applyingImg.jpg) !important;
        background-repeat: no-repeat;
    }

    .approvedEnImg {
        background-image: url(../../../assets/image/approvedEnImg.jpg) !important;
        background-repeat: no-repeat;
    }
    .approvedImg {
        background-image: url(../../../assets/image/approvedImg.jpg) !important;
        background-repeat: no-repeat;
    }

    .rejectedEnImg {
        background-image: url(../../../assets/image/rejectedEnImg.jpg) !important;
        background-repeat: no-repeat;
    }
    .rejectedImg {
        background-image: url(../../../assets/image/rejectedImg.jpg) !important;
        background-repeat: no-repeat;
    }

    .finishedEnImg {
        background-image: url(../../../assets/image/finishedEnImg.jpg) !important;
        background-repeat: no-repeat;
    }
    .finishedImg {
        background-image: url(../../../assets/image/finishedImg.jpg) !important;
        background-repeat: no-repeat;
    }

    .finishApproveEnImg {
        background-image: url(../../../assets/image/finishApproveEnImg.jpg) !important;
        background-repeat: no-repeat;
    }
    .finishApproveImg {
        background-image: url(../../../assets/image/finishApproveImg.jpg) !important;
        background-repeat: no-repeat;
    }

    .finishRejectEnImg {
        background-image: url(../../../assets/image/finishRejectEnImg.jpg) !important;
        background-repeat: no-repeat;
    }
    .finishRejectImg {
        background-image: url(../../../assets/image/finishRejectImg.jpg) !important;
        background-repeat: no-repeat;
    }

    .fontWeight {
        font-size: 14px;
    }

</style>
<style lang="scss">
    .uploadMsg {
        height: 30%;
        width: 40%;
        overflow: hidden;
        overflow-y: auto;
    }

    //全选icon
    .el-icon-my-selectAll {
        background: url('../../../assets/image/icon/selectAll.png') center center no-repeat;
        font-size: 16px;
        background-size: cover;
    }

    .el-icon-my-selectAll:before {
        content: "替";
        font-size: 16px;
        visibility: hidden;
    }

    //反选icon
    .el-icon-my-selectInverse {
        background: url('../../../assets/image/icon/selectInverse.png') center center no-repeat;
        font-size: 16px;
        background-size: cover;
    }

    .el-icon-my-selectInverse:before {
        content: "替";
        font-size: 16px;
        visibility: hidden;
    }
</style>